// Se importa el predicado y no la fachada `app/models/user`: esta arrastra i18n vía user.messages y
// dejaría de ser un modelo puro testeable a secas.
import { isOneclickAccount } from 'app/models/user/user.role';

// Restricción temporal (TAN-10280): mientras la digitalización se estabiliza, el punto de entrada solo
// se ofrece a las cuentas de OneClick. Retirarla es devolver `true` aquí.
export function canDigitalizeActivities(user) {
  return isOneclickAccount(user);
}
